import type { RenamePlan } from '@cli-types/core-engine/snapshots.js'

export function formatRenameSelectionSummary(plan: RenamePlan): string[] {
  const lines: string[] = []

  if (plan.fields.length > 0) {
    lines.push(
      `field renames: ${plan.fields.map((rename) => `${rename.before} -> ${rename.after}`).join(', ')}`
    )
  }

  if (plan.customCells.length > 0) {
    lines.push(
      `custom cell renames: ${plan.customCells.map((rename) => `${rename.before} -> ${rename.after}`).join(', ')}`
    )
  }

  return lines
}
